import Api from "../apiService";

class authApi {
  create(data) {
    return Api.postRequest(`auth/login`, data, {});
  }

  loginWithToken(token) {
    return Api.postRequest(`auth/login_with_token`, { token }, {});
  }
}

export default new authApi();
